import React from 'react'
import that from '../../translationHelper'
import Post from '../Post'
import notificationTypes from '../../../enums/notificationTypes'
import styles from './notificationDisplay.icss'

//	Helpers to show notifications
const notificationDisplay = {
	[notificationTypes['USER-TAGGED-IN-POST'].type]: {
		iconName: 'blackActivity',
		title: notification => that.context.translate('{username} tagged you in their post', {
			username: {
				value: notification.fromUsername,
				display: value => <span className={styles.name}>{value}</span>
			}
		}),
		subTitle: notification => Post.getPostTitleFromTimestamp(notification.createdTimestamp)
	},
	[notificationTypes['USER-FOLLOWED-YOU'].type]: {
		iconName: 'blackUser',
		title: notification => that.context.translate('{username} followed you', {
			username: {
				value: notification.fromUsername,
				display: value => <span className={styles.name}>{value}</span>
			}
		}),
		subTitle: () => that.context.translate('See their profile')
	},
	[notificationTypes['USER-VERIFIED-YOU'].type]: {
		iconName: 'blackUser',
		title: notification => that.context.translate('{username} verified you', {
			username: {
				value: notification.fromUsername,
				display: value => <span className={styles.name}>{value}</span>
			}
		}),
		subTitle: () => that.context.translate('See their profile')
	},
	[notificationTypes['FOLLOWING-POSTED'].type]: {
		iconName: 'blackUser',
		title: notification => that.context.translate('{username} created a new post', {
			username: {
				value: notification.fromUsername,
				display: value => <span className={styles.name}>{value}</span>
			}
		}),
		subTitle: () => that.context.translate('See the post')
	},
	[notificationTypes['USER-LIKED-YOUR-POST'].type]: {
		iconName: 'blackUser',
		title: notification => that.context.translate('{username} gave you kudos for your post', {
			username: {
				value: notification.fromUsername,
				display: value => <span className={styles.name}>{value}</span>
			}
		}),
		subTitle: notification => Post.getPostTitleFromTimestamp(notification.createdTimestamp)
	},
	[notificationTypes['YOU-WERE-ACTIVATED'].type]: {
		iconName: 'blackUser',
		title: notification => that.context.translate('You have been activated!', {
			username: {
				value: notification.fromUsername,
				display: value => <span className={styles.name}>{value}</span>
			}
		}),
		subTitle: () => that.context.translate('You now have full access to Kitfit')
	},
	[notificationTypes['USER-POST-RECEIVED-COMMENT'].type]: {
		iconName: 'blackUser',
		title: notification => that.context.translate('{username} commented on your post', {
			username: {
				value: notification.fromUsername,
				display: value => <span className={styles.name}>{value}</span>
			}
		}),
		subTitle: notification => Post.getPostTitleFromTimestamp(notification.createdTimestamp)
	},
	[notificationTypes['USER-PROFILE-INCOMPLETE'].type]: {
		iconName: 'blackUser',
		title: notification => that.context.translate('Your user profile is incomplete'), // eslint-disable-line no-unused-vars
		subTitle: () => that.context.translate('You need to fix it')
	},
	[notificationTypes['ITEM-TAGGED-IN-KIT'].type]: {
		iconName: 'blackKit',
		title: notification => that.context.translate('{username} tagged your item in their kit', { username: notification.fromUsername }),
		subTitle: () => that.context.translate('Check out their kit')
	}
}

export { notificationDisplay }
export default { notificationDisplay }



// WEBPACK FOOTER //
// ./src/utilities/Data/Notification/index.js